<template>
  <div
    class="brief-modal-overlay"
    @click.self="$emit('close')"
  >
    <div
      role="dialog"
      aria-labelledby="skuBriefTitle"
      class="brief-modal"
    >
      <div class="brief-modal-header">
        <div class="brief-modal-heading-row">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-file-text h-4 w-4 text-emerald-700"
          >
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
            <path d="M14 2v4a2 2 0 0 0 2 2h4" />
            <path d="M10 9H8" />
            <path d="M16 13H8" />
            <path d="M16 17H8" />
          </svg>
          <div class="brief-modal-title-group">
            <h2
              id="skuBriefTitle"
              class="brief-modal-title"
            >
              Content Brief
            </h2>
          </div>
          <div class="brief-modal-nav">
            <button
              type="button"
              class="brief-modal-nav-btn"
              aria-label="Previous brief"
              :disabled="currentIndex === 0"
              @click="currentIndex--"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-chevron-left h-4 w-4"
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>
            <span class="brief-modal-nav-label">
              Brief {{ currentIndex + 1 }} of {{ draftBriefs.length }}
            </span>
            <button
              type="button"
              class="brief-modal-nav-btn"
              aria-label="Next brief"
              :disabled="currentIndex === draftBriefs.length - 1"
              @click="currentIndex++"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-chevron-right h-4 w-4"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>

        <div
          v-if="currentDraft"
          class="brief-title-row"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-pencil brief-modal-meta-icon"
          >
            <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
            <path d="m15 5 4 4" />
          </svg>
          <input
            v-model="currentDraft.title"
            type="text"
            class="brief-title-input"
          >
        </div>

        <div
          v-if="currentDraft"
          class="brief-modal-assignee-row"
        >
          <div class="brief-assignee-select-wrap">
            <button
              type="button"
              role="combobox"
              aria-autocomplete="none"
              :aria-expanded="assigneeMenuOpen ? 'true' : 'false'"
              aria-controls="sku-brief-assignee-menu"
              class="brief-assignee-trigger"
              @click="toggleAssigneeMenu"
            >
              <span style="pointer-events: none;">
                <span class="brief-assignee-trigger-label">
                  <svg
                    v-if="currentDraft.assigneeType !== 'agency_partner'"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-user-plus brief-assignee-trigger-icon"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle
                      cx="9"
                      cy="7"
                      r="4"
                    />
                    <line
                      x1="19"
                      x2="19"
                      y1="8"
                      y2="14"
                    />
                    <line
                      x1="22"
                      x2="16"
                      y1="11"
                      y2="11"
                    />
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-building2 brief-assignee-trigger-icon"
                  >
                    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                    <path d="M10 6h4" />
                    <path d="M10 10h4" />
                    <path d="M10 14h4" />
                    <path d="M10 18h4" />
                  </svg>
                  {{ currentDraft.assigneeType === 'agency_partner' ? 'Agency partner' : 'Specific Person' }}
                </span>
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-chevron-down brief-assignee-trigger-chevron"
                aria-hidden="true"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>

            <div
              v-if="assigneeMenuOpen"
              id="sku-brief-assignee-menu"
              class="brief-assignee-menu"
              role="presentation"
            >
              <button
                type="button"
                role="option"
                class="brief-assignee-option"
                :class="{ 'is-selected': currentDraft.assigneeType === 'specific_person' }"
                @click="setAssigneeType('specific_person')"
              >
                <span class="brief-assignee-option-check">
                  <svg
                    v-if="currentDraft.assigneeType === 'specific_person'"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-check brief-assignee-check-icon"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </span>
                <span class="brief-assignee-option-label">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-user-plus brief-assignee-option-icon"
                    aria-hidden="true"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle
                      cx="9"
                      cy="7"
                      r="4"
                    />
                    <line
                      x1="19"
                      x2="19"
                      y1="8"
                      y2="14"
                    />
                    <line
                      x1="22"
                      x2="16"
                      y1="11"
                      y2="11"
                    />
                  </svg>
                  Specific Person
                </span>
              </button>

              <button
                type="button"
                role="option"
                class="brief-assignee-option"
                :class="{ 'is-selected': currentDraft.assigneeType === 'agency_partner' }"
                @click="setAssigneeType('agency_partner')"
              >
                <span class="brief-assignee-option-check">
                  <svg
                    v-if="currentDraft.assigneeType === 'agency_partner'"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-check brief-assignee-check-icon"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </span>
                <span class="brief-assignee-option-label">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-building2 brief-assignee-option-icon"
                    aria-hidden="true"
                  >
                    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                    <path d="M10 6h4" />
                    <path d="M10 10h4" />
                    <path d="M10 14h4" />
                    <path d="M10 18h4" />
                  </svg>
                  Agency partner
                </span>
              </button>
            </div>
          </div>

          <input
            v-model="currentDraft.assigneeName"
            type="text"
            class="brief-inline-control brief-inline-assignee"
            placeholder="person@brand.com"
          >
          <input
            v-model="currentDraft.delivery_date"
            type="date"
            class="brief-inline-control brief-inline-date"
          >
        </div>
      </div>

      <div
        v-if="currentDraft"
        class="brief-modal-content"
      >
        <div class="brief-modal-content-section">
          <label class="brief-modal-label">Overview</label>
          <textarea
            v-model="currentDraft.overviewText"
            rows="3"
          />
        </div>
        <div class="brief-modal-content-section">
          <label class="brief-modal-label">Deliverables</label>
          <textarea
            v-model="currentDraft.deliverablesText"
            rows="8"
          />
        </div>
        <div
          v-if="currentDraftResult && !currentDraftResult.success"
          class="brief-modal-error"
        >
          {{ currentDraftResult.error }}
        </div>
      </div>

      <div class="brief-modal-divider" />

      <div class="brief-modal-footer">
        <button
          type="button"
          class="brief-modal-btn-outline"
          :disabled="currentIndex === draftBriefs.length - 1"
          @click="currentIndex++"
        >
          Next brief
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-right brief-modal-meta-icon"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
        <button
          type="button"
          class="brief-modal-btn"
          :disabled="isSubmitting"
          @click="$emit('submit', { drafts: draftBriefs })"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-user-plus brief-modal-btn-icon"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle
              cx="9"
              cy="7"
              r="4"
            />
            <line
              x1="19"
              x2="19"
              y1="8"
              y2="14"
            />
            <line
              x1="22"
              x2="16"
              y1="11"
              y2="11"
            />
          </svg>
          {{ submitLabel }}
        </button>
      </div>

      <button
        type="button"
        class="brief-modal-close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <i class="bi bi-x" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductReportsDashboardSkuBriefModal',

  props: {
    briefs: {
      type: Array,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    submitResults: {
      type: Array,
      default: () => ([]),
    },
  },

  emits: ['submit', 'close'],

  data() {
    return {
      currentIndex: 0,
      draftBriefs: [],
      assigneeMenuOpen: false,
    };
  },

  computed: {
    currentDraft() {
      return this.draftBriefs[this.currentIndex] || null;
    },

    currentDraftResult() {
      if (!this.currentDraft) return null;
      return this.submitResults.find(r => r.rowKey === this.currentDraft.rowKey) || null;
    },

    failedCount() {
      return this.submitResults.filter(r => !r.success).length;
    },

    submitLabel() {
      if (this.isSubmitting) {
        const total = this.draftBriefs.length;
        const done = Math.min(this.submitResults.filter(r => r.success !== null).length + 1, total);
        return `Creating ${done}/${total}...`;
      }
      if (this.failedCount > 0) return `Retry ${this.failedCount} failed`;
      return `Create ${this.draftBriefs.length} ${this.draftBriefs.length === 1 ? 'brief' : 'briefs'}`;
    },
  },

  watch: {
    currentIndex() {
      this.assigneeMenuOpen = false;
    },
  },

  created() {
    this.draftBriefs = this.briefs.map(b => ({
      ...b,
      assigneeType: b.assigneeType || 'specific_person',
      assigneeDefaultName: b.assigneeDefaultName || b.assigneeName || '',
      assigneeName: b.assigneeName || '',
    }));
  },

  methods: {
    toggleAssigneeMenu() {
      this.assigneeMenuOpen = !this.assigneeMenuOpen;
    },

    setAssigneeType(type) {
      if (!this.currentDraft) return;

      this.currentDraft.assigneeType = type;
      if (type === 'agency_partner') {
        this.currentDraft.assigneeName = 'support@itsrapid.ai';
      } else {
        this.currentDraft.assigneeName = this.currentDraft.assigneeDefaultName || this.currentDraft.assigneeName || '';
      }

      this.assigneeMenuOpen = false;
    },
  },
};
</script>

<style scoped>
*, *:before, *:after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e5e7eb;
}

button, input:where([type=button]), input:where([type=reset]), input:where([type=submit]) {
  appearance: button;
  -webkit-appearance: button;
  background-color: transparent;
  background-image: none;
}

/* ── Copied from ProductReportsDashboardBriefModal ── */

.brief-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2101;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: rgba(15, 23, 42, 0.3);
}

.brief-modal {
  position: relative;
  width: min(100%, 680px);
  border: 1px solid #dde5ef;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.24);
  display: flex;
  flex-direction: column;
  height: min(90vh, 700px);
}

.brief-modal-header {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e3e9f2;
}

.brief-modal-title {
  color: #111827;
  font-size: 20px;
  line-height: 1.12;
  letter-spacing: -0.01em;
  font-weight: 700;
  margin: 0;
}

.brief-title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.brief-title-input {
  height: 2rem;
  width: 100%;
  border-radius: 0.375rem;
  border: 1px dashed #d1d5db;
  background: #ffffff;
  padding: 0 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
}

.brief-title-input:focus {
  outline: none;
  border-color: #059669;
  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.1);
}

.brief-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.brief-modal-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.brief-modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 1.5rem;
}

.brief-modal-label {
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #059669;
  margin-bottom: 0;
  display: block;
}

textarea {
  display: flex;
  min-height: 80px;
  width: 100%;
  border-radius: 0.375rem;
  border: 1px solid #e2e8f0;
  padding: 0.75rem;
  font-size: 0.875rem;
  background: #fff;
  resize: vertical;
  box-sizing: border-box;
}

textarea:focus {
  outline: none;
  border-color: #059669;
  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.1);
}

.brief-modal-footer {
  border-top: 1px solid #e3e9f2;
  padding: 0.75rem 1.5rem;
  background: rgba(248, 250, 252, 0.5);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
}

.brief-modal-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0.375rem;
  padding: 0.75rem;
  gap: 0.375rem;
  height: 2.25rem;
  border: 0;
  background: #059669;
  color: #fff;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.brief-modal-btn:hover {
  background: #047857;
}

.brief-modal-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.brief-modal-content-section {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  font-size: .875rem;
  line-height: 1.25rem;
  padding-top: 0.75rem;
  overflow-y: auto;
}

/* ── SkuBriefModal additions ── */

.brief-modal-heading-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-right: 40px;
}

.brief-modal-title-group {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.brief-modal-nav {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.brief-modal-nav-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: transparent;
  cursor: pointer;
  padding: 0;
  color: #374151;
}

.brief-modal-nav-btn:hover:not(:disabled) {
  background: #f1f5f9;
}

.brief-modal-nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.brief-modal-nav-label {
  font-size: 0.75rem;
  color: #64748b;
  font-variant-numeric: tabular-nums;
  padding: 0 0.25rem;
}

.brief-modal-assignee-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding-left: 18px;
  margin-top: 0.5rem;
}

.brief-assignee-select-wrap {
  position: relative;
  flex: 0 0 auto;
}

.brief-assignee-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 180px;
  height: 2rem;
  padding: 0 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #d5dde8;
  background: #ffffff;
  color: #111827;
  font-size: 0.875rem;
  gap: 0.375rem;
  cursor: pointer;
}

.brief-assignee-trigger:focus {
  outline: none;
  border-color: #059669;
  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.1);
}

.brief-assignee-trigger-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.brief-assignee-trigger-icon {
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0;
  color: rgb(4 120 87);
}

.brief-assignee-trigger-chevron {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  opacity: 0.5;
  color: #6b7280;
}

.brief-assignee-menu {
  position: absolute;
  z-index: 10;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  padding: 0.25rem;
  border: 1px solid #d5dde8;
  border-radius: 0.375rem;
  background: #ffffff;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.12);
}

.brief-assignee-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.5rem;
  border-radius: 0.25rem;
  background: transparent;
  color: #111827;
  font-size: 0.875rem;
  text-align: left;
  cursor: pointer;
}

.brief-assignee-option:hover,
.brief-assignee-option.is-selected {
  background: #f0fdf4;
}

.brief-assignee-option-check {
  width: 0.875rem;
  height: 0.875rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.brief-assignee-option-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.brief-assignee-option-icon {
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0;
  color: rgb(4 120 87);
}

.brief-assignee-check-icon {
  width: 1rem;
  height: 1rem;
  color: #111827;
}

.brief-inline-control {
  height: 2rem;
  width: 100%;
  border-radius: 0.375rem;
  border: 1px solid #d5dde8;
  background: #ffffff;
  padding: 0 0.625rem;
  font-size: 0.875rem;
  color: #111827;
}

.brief-inline-control:focus {
  outline: none;
  border-color: #059669;
  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.1);
}

.brief-inline-assignee {
  min-width: 200px;
  flex: 1 1 220px;
}

.brief-inline-date {
  width: 150px;
  flex: 0 0 150px;
}

.brief-modal-meta-icon {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  color: #94a3b8;
}

.brief-modal-btn-icon {
  width: 1rem;
  height: 1rem;
}

.brief-modal-btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  height: 2.25rem;
  padding: 0 0.75rem;
  border-radius: 6px;
  border: 1px solid #e2e2e2;
  background: #ffffff;
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
  cursor: pointer;
  transition: background-color 0.15s;
  white-space: nowrap;
}

.brief-modal-btn-outline:hover {
  background: #f0f0f0;
}

.brief-modal-btn-outline:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.brief-modal-divider {
  flex-shrink: 0;
  height: 1px;
  width: 100%;
  background-color: #e2e8f0;
}

.brief-modal-error {
  font-size: 0.875rem;
  color: #dc2626;
  margin-top: 0.5rem;
}

.text-emerald-700 {
  color: rgb(4 120 87);
}

.h-4 { height: 1rem; }
.w-4 { width: 1rem; }
</style>
